import React from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { signInCheck } from '../../common/CheckUserStatus';
import { storageAvailable } from '../../common/storageAvailable';
import { signout } from '../../../userauth/actions/signinAction';
import { generateEvent } from '../../../utils/dataGrinch';
import properties from '../../../modules/ajio-util/properties';
import { isServerRendering } from '../../../utils/pageInfo';
import { getAssetConfig } from '../../../refresh/selectors/featureFlagsSelector';

class Navigation extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      showItems: [],
      childSecVisible: [],
      childThirdVisible: []
    };
    this.scrolledElement = null;
  }

  scrollOnElement = element => {
    this.scrolledElement = element;
  };

  showChild = (index, title) => {
    let showItems = this.state.showItems.slice(index, 1);
    showItems[index] = !this.state.showItems[index];
    this.generateLevelCLick({
      action: showItems[index] ? 'OPEN' : 'CLOSE',
      index,
      title
    });
    this.setState({ showItems });
  };

  generateLevelCLick({ level = '', action = '', index = '', title = '' }) {
    generateEvent({
      Event: `Drawer${level}LinkClick`,
      value: {
        Screen: 'Mobile',
        LinkIndex: index,
        Action: action,
        LinkName: title
      }
    });
  }

  linkClick(link, name, type = 'DrawerLinkClick') {
    generateEvent({
      Event: type,
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'Mobile'
      }
    });
    // window.location = link;
  }

  showSecChild = (l, title) => {
    let childSecVisible = this.state.childSecVisible.slice();
    childSecVisible[l] = !this.state.childSecVisible[l];
    if (this.scrolledElement) {
      this.scrolledElement.scrollIntoView({ behaviour: 'smooth' });
    }
    this.generateLevelCLick({
      level: 'SecondLevel',
      action: 'OPEN',
      index: l,
      title
    });
    this.setState({ childSecVisible });
  };

  hideSecChild = (l, title) => {
    let childSecVisible = this.state.childSecVisible.slice();
    childSecVisible[l] = !this.state.childSecVisible[l];
    this.generateLevelCLick({
      level: 'SecondLevel',
      action: 'HIDE',
      index: l,
      title
    });
    this.setState({ childSecVisible });
  };

  showThirdChild = (index, title) => {
    let childThirdVisible = this.state.childThirdVisible.slice(index, 1);
    childThirdVisible[index] = !this.state.childThirdVisible[index];
    this.generateLevelCLick({
      level: 'ThirdLevel',
      action: childThirdVisible[index] ? 'OPEN' : 'CLOSE',
      index,
      title
    });
    this.setState({ childThirdVisible });
  };

  showStaticChild = () => {
    this.setState(prevState => {
      return { show: !prevState.show };
    });
  };

  componentDidMount() {
    if (storageAvailable('localStorage')) {
      localStorage.setItem('vertialidlocal', '0');
    }
  }

  render() {
    let isSignedIn = signInCheck();
    let {
      navigation: navdata = {},
      myaccount: staticData = {},
      metaData: { sis = false, current: { navigation: subStoreNavigation } = {} } = {},
      location = {},
      loginURL = '',
      assetConfig = {}
    } = this.props;
    let imageBaseUrl = properties.getProperty('imageBaseUrl') || 'https://assets-jiocdn.ajio.com';
    const isJioCDNEnabled = assetConfig && assetConfig.isJioCDNEnabled === 'ON';
    if(isJioCDNEnabled) {
      imageBaseUrl = assetConfig?.jioCDNAssetUrl || '';
    }
    let logoURL = `${imageBaseUrl}/static/img/ajio.png`;
    let logoTextURL = `${imageBaseUrl}/static/img/Ajio-Logo.png`;
    let pathname = '';
    if (!isServerRendering()) {
      const { location = {} } = window;
      pathname = location.pathname;
    } else {
      pathname = location.path ? location.path : '';
    }

    if (sis) {
      navdata = subStoreNavigation;
    }
    if (_isEmpty(navdata) || _isEmpty(staticData)) return null;

    let redirectURL =
      loginURL && sis
        ? `${properties.getProperty('parentUrl')}/login?referrer=${loginURL}`
        : `${properties.getProperty('parentUrl')}/login`;

    let { childDetails: staticDetail = [] } = staticData;

    const myAccountLink = staticDetail.map((childDetails, i) => {
      if (childDetails.title === 'OTHER') {
        return childDetails.linkDetails.map((linkDetails, j) => {
          const { linkName = '', url = '', fullUrl } = linkDetails;
          let hrefUrl = fullUrl || url;
          let linkToClick = url;
          let typeOfLink;
          if (linkName.toLowerCase() === 'recently viewed') {
            hrefUrl = `${properties.getProperty('parentUrl')}/recentview`;
            linkToClick = '/recentview';
            typeOfLink = 'DrawerLinkClick';
          }
          return (
            <a
              key={j}
              href={hrefUrl}
              onClick={() => {
                this.linkClick(linkToClick, linkName, typeOfLink);
              }}
            >
              {linkName.toLowerCase()}
            </a>
          );
        });
      }
    });

    const staticLink = staticDetail.map(childDetails => {
      if (childDetails.title === 'ABOUT AJIO') {
        return childDetails.linkDetails.map((linkDetails, j) => {
          let { url = '', fullUrl, linkName } = linkDetails;
          return (
            <li key={j}>
              <a href={fullUrl || url} onClick={() => this.linkClick(fullUrl || url, linkName)}>
                {linkName}
              </a>
            </li>
          );
        });
      }
    });

    const aboutAjioText = staticDetail.map((childDetails, i) => {
      if (childDetails.title === 'ABOUT AJIO') {
        return <span key={i}>{childDetails.title.toLowerCase()}</span>;
      }
    });

    const { childDetails = [] } = navdata;

    const nav = childDetails.map((itemfirst, index) => {
      const { linkDetails, fullUrl, url, title = '', newFlag = false, childDetails } = itemfirst;
      const divStyle = {
        textDecoration: 'none',
        display: 'inline-block',
        width: '100%'
      };
      let firstMegaClass = 'first-mega navbar-close-mobile';
      let chevronClass = 'ic-plus';
      if (this.state.showItems[index]) {
        firstMegaClass = 'first-mega';
        chevronClass = 'ic-minus';
      }

      return (
        <li key={index}>
          {linkDetails ? (
            <div className="link-item1" onClick={() => this.showChild(index, title)}>
              <span dangerouslySetInnerHTML={{ __html: itemfirst.title }} />
              <span className={chevronClass} />
            </div>
          ) : (
            <a
              href={fullUrl || url}
              href={fullUrl || url}
              style={divStyle}
              onClick={() => this.linkClick(fullUrl || url, title)}
            >
              <div className="link-item1 gold-text">
                {title}
                {newFlag && <span className="newtag-mobile">NEW</span>}
              </div>
            </a>
          )}
          {
            <div key={index} className={firstMegaClass}>
              <ul className="level-first">
                {linkDetails
                  ? linkDetails.map((item, k) => {
                      const { fullUrl, url = '', linkName } = item;
                      return (
                        <li key={k}>
                          <a
                            href={fullUrl || url}
				                    aria-label={linkName}
                            onClick={() => this.linkClick(fullUrl || url, linkName)}
                          >
                            {linkName}
                          </a>
                        </li>
                      );
                    })
                  : null}
              </ul>

              {childDetails ? (
                <ul className="level-sec">
                  {childDetails.map((itemsec, l) => {
                    return (
                      <li key={l}>
                        <div
                          className="link-item2"
                          onClick={() => this.showSecChild(l, itemsec.title)}
                        >
                          {itemsec.title}
                          <span className="ic-rchevron" />
                        </div>

                        {childDetails && this.state.childSecVisible[l] ? (
                          <ul className="sec-mega">
                            <div
                              ref={this.scrollOnElement}
                              className="link-item2"
                              style={{ justifyContent: 'flex-start' }}
                              onClick={() => this.hideSecChild(l, itemsec.title)}
                            >
                              <span className="ic-lchevron" />
                              {itemsec.title}
                            </div>
                            {itemsec.linkDetails ? (
                              <ul className="third-megatop">
                                {itemsec.linkDetails.map((item, n) => {
                                  return (
                                    <li key={n}>
                                      <a
                                        href={item.fullUrl || item.url}
                                        onClick={() => {
                                          this.linkClick(item.fullUrl || item.url, item.linkName);
                                        }}
                                      >
                                        {item.linkName}
                                      </a>
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : null}

                            {itemsec.childDetails
                              ? itemsec.childDetails.map((itemthird, m) => {
                                  return (
                                    <li key={m}>
                                      <div
                                        className="link-item3"
                                        onClick={() => this.showThirdChild(m, itemthird.title)}
                                      >
                                        <a
                                          href={itemthird.fullUrl || itemthird.url}
                                          onClick={() =>
                                            this.linkClick(
                                              itemthird.fullUrl || itemthird.url,
                                              itemthird.title
                                            )
                                          }
                                        >
                                          {itemthird.title}
                                        </a>
                                        <span
                                          className={
                                            this.state.childThirdVisible[m] ? 'ic-minus' : 'ic-plus'
                                          }
                                        />
                                      </div>
                                      {this.state.childThirdVisible[m] && itemthird.linkDetails ? (
                                        <ul className="third-mega">
                                          {itemthird.linkDetails.map((itemfour, i) => {
                                            return (
                                              <li key={i}>
                                                <a
                                                  href={itemfour.fullUrl || itemfour.url}
                                                  style={{ justifyContent: 'flex-start' }}
                                                  onClick={() =>
                                                    this.linkClick(
                                                      itemfour.fullUrl || itemfour.url,
                                                      itemfour.linkName
                                                    )
                                                  }
                                                >
                                                  {itemfour.linkName}
                                                </a>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      ) : null}
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
          }
        </li>
      );
    });

    return (
      <div className={`navigation-list ${this.props.className}`}>
        <ul className="menu-items">
          <li className="brand-navigation">
            <span
              className="ic-menuopen"
              onClick={this.props.toggleMenu}
              style={{ color: '#b19975' }}
            />
            <a href={sis ? `${properties.getProperty('parentUrl')}` : '/'}>
              <img
                src={logoURL}
                onError={e => {
                  console.log(e);
                  e.target.src = `${imageBaseUrl}/static/img/ajio.png`;
                }}
                className="header-brand-icon brand-logo"
                alt="Ajio logo"
              />
              <img
                src={logoTextURL}
                onError={e => {
                  console.log(e);
                  e.target.src = `${imageBaseUrl}/static/img/Ajio-Logo.png`;
                }}
                className="header-brand-icon brand-name"
                alt="Ajio logo"
              />
            </a>
          </li>
          {nav}
          {isSignedIn ? (
            <ul className="myacc-link">
              <li className="login-txt">
                <a
                  href={`${properties.getProperty('parentUrl')}/my-account/`}
                  onClick={() => {
                    this.linkClick('/my-account', 'MY ACCOUNT', 'DrawerClick');
                  }}
                >
                  My Account
                  <span className="sentence-case">({isSignedIn})</span>
                </a>
                <a
                  onClick={() => {
                    this.props.signout(() => {
                      this.linkClick('/logout', 'LOGOUT', 'DrawerClick');
                      window.location = '/';
                      window?.copilot?.users.unset();
                    });
                  }}
                  title='acts as button'
                >
                  Sign Out
                </a>
              </li>
              <li>{myAccountLink}</li>
            </ul>
          ) : (
            <ul className="myacc-link">
              <li className="login-txt">
                <a
                  href={redirectURL}
                  onClick={() => {
                    this.linkClick('/login', 'Sign In', 'DrawerClick');
                  }}
                >
                  Sign In
                </a>
              </li>
              <li>{myAccountLink}</li>
            </ul>
          )}

          <ul className="static-link">
            <li className="about-ajiotxt" onClick={this.showStaticChild}>
              <a href="#about-ajio">
                {aboutAjioText}
                <span className={this.state.show ? 'ic-chevronup' : 'ic-chevrondown'} />
              </a>
            </li>
            {this.state.show ? (
              <ul className="aboutajio-sec" id="about-ajio">
                {staticLink}
              </ul>
            ) : null}
          </ul>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const assetConfig = getAssetConfig(state?.flags);
  return {
    navigation: state.navigation,
    myaccount: state.myaccount,
    metaData: state.metaData,
    assetConfig
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signout: cb => {
      dispatch(signout(cb));
    }
  };
};

export default Navigation = connect(mapStateToProps, mapDispatchToProps)(Navigation);
